import { useCallback, useEffect, useState } from 'react';
import deliveryService from '../services/deliveryService';

/**
 * Delivery companies (sorted by sort order). `activeOnly` hides deactivated ones - use it for price
 * entry; the order filters keep inactive companies too since old orders still reference them.
 * A failed fetch (e.g. missing permission) just yields an empty list.
 */
export const useDeliveryCompanies = ({ activeOnly = false } = {}) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const all = await deliveryService.getCompanies();
      setCompanies(activeOnly ? all.filter((c) => c.active) : all);
    } catch {
      setCompanies([]);
    } finally {
      setLoading(false);
    }
  }, [activeOnly]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { companies, loading, reload };
};
